'use client'

import React, { useState, useEffect, useRef } from "react"
import { Swiper, SwiperSlide } from "swiper/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight, faChevronLeft } from "@fortawesome/free-solid-svg-icons";

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import { Pagination, Navigation } from 'swiper/modules';
import CardEbook from "@/app/component/Card/CardB";
import Link from "next/link";

const BookSlideSetB = ({ data }) => {
    const prevRef = useRef(null);
    const nextRef = useRef(null);

    const Alldata = data[0]

    const breakpoint = {
        744: {
            slidesPerView: 1,
            spaceBetween: 40,
        },
        960: {
            slidesPerView: 2,
            spaceBetween: 30,
        },
        1280: {
            slidesPerView: 2,
            spaceBetween: 30,
        },
        1440: {
            slidesPerView: 2,
            spaceBetween: 30,
        },
    }

    return (
        <>
            <div className="flex items-center justify-between text-[20px] xl:text-[24px] font-medium my-[0.5em]">
                <div className="flex items-center gap-[5px]">
                    <img
                        src="https://eve-image.eveebook.com/image.eveebook/mascot/happy.png"
                        alt="happy_rabbit"
                        className="w-[52px]"
                        loading="lazy"
                        decoding="async"
                        width={52}
                        height={52}
                    />
                    <div className="py-[24px] text-primary">{Alldata.column_data.order_name}</div>
                    <div className="text-special">{Alldata.column_data.order_discount}</div>
                </div>
                <Link
                    href={Alldata?.column_data?.auto_key === 'preorder' ? '/preorder' : `/column/${Alldata?.column_data?.id}`}
                    className="text-sm md:text-base text-special hover:text-[#EC008C] transition-colors font-normal flex items-center gap-1"
                >
                    ดูเพิ่มเติม &gt;
                </Link>
            </div>
            <div className="relative mx-0 md:mx-[5%] xl:mx-0 ">
                <div className="flex justify-between mb-2">
                    <button ref={prevRef} className="swiper-prev-btn EbookSetSwiper"><FontAwesomeIcon size="2xl" icon={faChevronLeft} /></button>
                    <button ref={nextRef} className="swiper-next-btn EbookSetSwiper"><FontAwesomeIcon size="2xl" icon={faChevronRight} /></button>
                </div>
                <Swiper
                    className=""
                    modules={[Navigation]}
                    breakpoints={breakpoint}
                    navigation={{
                        prevEl: prevRef.current,
                        nextEl: nextRef.current,
                    }}
                    onInit={(swiper) => {
                        swiper.params.navigation.prevEl = prevRef.current;
                        swiper.params.navigation.nextEl = nextRef.current;
                        swiper.navigation.init();
                        swiper.navigation.update();
                    }}
                >
                    {Alldata.column_book
                        ?.slice()
                        .sort((a, b) => {
                            if (a?.sort_order != null && b?.sort_order != null) {
                                return a.sort_order - b.sort_order
                            }
                            const orderA = Array.isArray(a?.order_id) ? (a.order_id[0]?.order ?? 0) : 0
                            const orderB = Array.isArray(b?.order_id) ? (b.order_id[0]?.order ?? 0) : 0
                            return orderA - orderB
                        })
                        .map((ebookdata, index) => (
                            <SwiperSlide key={index}>
                                <CardEbook Ebookdata={ebookdata} type="SeriesToBook" />
                            </SwiperSlide>
                        ))}
                </Swiper>
            </div>
        </>
    )
}

export default BookSlideSetB